<bom-workspace>
  <ng-container *ngIf="mitIdSigneringRequest && !showSpinner">
    <div class="iframe-container">
      <iframe
        id="signing-window"
        width="100%"
        height="100%"
        frameBorder="0"
        [src]="safeSigningClientUrl"
      ></iframe>
    </div>
  </ng-container>
  <ng-container *ngIf="showSpinner">
    <bom-spinner [message]="spinnerText"></bom-spinner>
  </ng-container>
</bom-workspace>
